var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusNotChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not_chacked",
    "data-name": "not chacked",
    transform: "translate(-11338.268 -171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(11338.268 171)",
    fill: "#fae3e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(11345.15 179.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M24.052,14.663a1.238,1.238,0,0,1,1.786.014,1.409,1.409,0,0,1,.047,1.883l-6.836,9.016a1.239,1.239,0,0,1-1.85.036l-4.534-4.781a1.4,1.4,0,0,1-.369-1.327,1.322,1.322,0,0,1,.927-.978,1.243,1.243,0,0,1,1.258.389L18.069,22.7l5.951-8a.476.476,0,0,1,.034-.04Z",
    transform: "translate(-12.256 -14.29)",
    fill: "#fff",
    opacity: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNotChecked);
export default __webpack_public_path__ + "static/media/status-not-checked.49cf121cff7d35d262ff0e93e3ee6c72.svg";
export { ForwardRef as ReactComponent };